/* eslint-disable function-paren-newline */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  BodyContainer,
  Header,
  HeaderContainer
} from '../MasterCheckList/masterCheckList.styles';
import TabsTable from '../../../component/Common/Tabs_Table';
import Toast from '../../../component/Common/Toast';
import { useActions } from '../../../store/hooks/useActions';
import { fetchUserAndLocation } from '../../../component/Sidenav/fetchPageStatistics';
import { sagaCatchBlockHandling } from '../../../store/utility/sagaErrorHandling';
import { WebService } from '../../../services/axios/webServices';
import { mimeTypes } from '../constants';

const RepositoryChecklist = () => {
  const [pageSize, setPageSize] = useState(20);
  const [error, setError] = useState();

  const {
    repoChecklistSearchQueries,
    repoChecklistData,
    repoChecklistMeta,
    isLoading: repoChecklistLoading
  } = useSelector((state) => state.checkListDetails);

  const {
    getRepoChecklist,
    setRepoChecklistSearchQueries,
    resetRepoChecklistSearchQueries
  } = useActions();

  const location = useLocation();

  const { userData } = useSelector((state) => state.loginData);
  const { finalMenu } = useSelector((state) => state.home);

  const setAssetSearchQueries = (searchQueries) => {
    setRepoChecklistSearchQueries(searchQueries);
  };

  const resetSearchQueries = () => {
    resetRepoChecklistSearchQueries();
  };

  const name = finalMenu.find((ele) => ele.path === location.pathname);

  const handlePageChange = (page, rest = {}) => {
    const { searchParams } = rest;
    getRepoChecklist({ page, pageSize, searchParams });
  };

  /**
   *Function which receives url and makes call to api to download filename
   * @param {*} url
   * @returns blob with data to be downloaded
   */
  function toDataURL(url) {
    return WebService.get(url, { responseType: 'blob' }).then((response) => {
      const contentType = response.headers['content-type'];

      const mimeType = Object.keys(mimeTypes).find((type) =>
        contentType.includes(type.split('/')[1])
      );
      if (!mimeType) {
        throw new Error('Unsupported file type');
      }

      if (mimeType === 'text/plain') {
        return response.data.text().then((text) => {
          const blob = new Blob([text], { type: mimeType });
          return URL.createObjectURL(blob);
        });
      }

      const blob = new Blob([response.data], { type: mimeType });
      return URL.createObjectURL(blob);
    });
  }

  /**
   * Function Which is called on  click of Template name for downloading
   */
  const downloadFile = async (entry) => {
    try {
      const fullUrl = `${entry?.FileDownloadlink}`;
      // eslint-disable-next-line prefer-const, object-shorthand
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = await toDataURL(fullUrl);
      a.download = entry?.filename.replace(/[/?:><*|.]/g, '');
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      const payload = sagaCatchBlockHandling(err);
      setError(payload?.error);
    }
  };

  useEffect(() => {
    fetchUserAndLocation(location.pathname, userData, {
      pageType: name?.name
    });
  }, []);

  useEffect(() => {
    handlePageChange(1);
  }, [pageSize]);

  return (
    <div>
      <HeaderContainer>
        <Header>{name?.description}</Header>
      </HeaderContainer>
      <BodyContainer>
        <TabsTable
          metaDetails={repoChecklistMeta}
          dataDetails={repoChecklistData}
          showPagiation={true}
          showShortlistSelection={false}
          handlePageChange={handlePageChange}
          styleType='spareTable'
          noItemsFoundMessage='No Data Found'
          showRowOptionAtStart={false}
          id='UserID'
          onItemSelect={() => {}}
          onHyperLinkSelect={downloadFile}
          saveSearchQueries={setAssetSearchQueries}
          savedSearchQueries={repoChecklistSearchQueries}
          resetSearchQueries={resetSearchQueries}
          pageSize={pageSize}
          setPageSize={setPageSize}
          assetListLoading={repoChecklistLoading}
        />
        {error && (
          <Toast
            message={error}
            header='Error'
            style={{ right: 30 }}
            fn={() => setError('')}
          />
        )}
      </BodyContainer>
    </div>
  );
};

export default RepositoryChecklist;
